
export class DateUtil {

	public static get today(): Date {
		return new Date();
	}

	public static isToday(date: Date): boolean {
		return date.getDate() == this.today.getDate() && date.getMonth() == this.today.getMonth() && date.getFullYear() == this.today.getFullYear();
	}

	public static inLastHour(date: Date): boolean {
		const HOUR = 1000 * 60 * 60;
		const anHourAgo = Date.now() - HOUR;

		return date.getTime() > anHourAgo;
	}

	public static inLastWeek(date: Date): boolean {

		const now = new Date();
		const dayOfWeek = now.getDay(); //0-6
		const numDay = now.getDate();

		// cacular primer dia de la semana
		const start = new Date(now);
		start.setDate(numDay - dayOfWeek);
		start.setHours(0, 0, 0, 0);

		return date.getTime() > start.getTime();
	}
}
